// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__sCHnU","ranges":"BmiRanges_ranges__3Udvx"};